document.addEventListener("DOMContentLoaded", function() {

    /**
   * updates the product view when a product attribute is selected or deselected or when
   *         changing quantity
   * @param {string} selectedValueUrl - the Url for the selected variation value
   * @param {jQuery} $productContainer - DOM element for current product
   */
    function attributeSelect(selectedValueUrl, $productContainer) {
        // $(".pdpLoader").show();
        if (selectedValueUrl) {
            $("body").trigger("product:beforeAttributeSelect", {
                url:       selectedValueUrl,
                container: $productContainer
            });

            $.ajax({
                url:     selectedValueUrl,
                method:  "GET",
                success: function(data) {                    
                    handleVariantResponse(data, $productContainer);
                    updateOptions(data.product.optionsHtml, $productContainer);
                    updateQuantities(data.product.quantities, $productContainer);
                    hideDisabledSizes(data);
                    checkDisabledColors(data);
                    updateImage(data.product.images.large, data.product.images.pemblem);
                    $("body").trigger("product:afterAttributeSelect", {
                        data:      data,
                        container: $productContainer                        
                    });
                    console.log('after data',data);
                    $.spinner().stop();
                    // $(".pdpLoader").hide();
                },
                error: function() {
                    $.spinner().stop();
                }
            });
        }
    }

    function attachImageListeners() {
        var imagesWrapper = document.querySelector(".images-wrapper");
        var productImages = imagesWrapper.querySelectorAll(
            ".product-colors-image"
        );

        // Handle product image selection
        productImages.forEach(function(imageContainer) {
            imageContainer.addEventListener("click", function() {
                // Update selected image
                var imageSelected = this.querySelector("img").getAttribute("src");
                document
                    .querySelector(".Product-image img")
                    .setAttribute("src", imageSelected);

                // Remove border from all images
                productImages.forEach(function(img) {
                    img.classList.remove("product-colors-image-border");
                });
                // Add border to the selected image
                this.classList.add("product-colors-image-border");
            });
        });
    }

    function updateImage(images, pemblem) {
        if (window.resetThumbnailScroll) {
        window.resetThumbnailScroll();
        }
        if (pemblem && pemblem.length > 0 && pemblem[0].url) {
            $("#emblemQr").attr("src", pemblem[0].url);
        }
        // Select the existing image wrapper container
        var Imagewrappercontainer = document.querySelector(
            ".images-wrapper-container"
        );
        var upButton = document.querySelector(".up-button");
        var downButton = document.querySelector(".down-button");
        if (images.length <= 5) {
            if (upButton) upButton.classList.add("d-none");
            if (downButton) downButton.classList.add("d-none");
        } else {
            if (upButton) upButton.classList.remove("d-none");
            if (downButton) downButton.classList.remove("d-none");
        }

        // Remove all existing images
        while (Imagewrappercontainer.firstChild) {
            Imagewrappercontainer.removeChild(Imagewrappercontainer.firstChild);
        }

        // Create the new wrapper element
        var wrapper = document.createElement("div");
        wrapper.classList.add("images-wrapper");
        wrapper.style.transform = "translateY(0px)";

        // Loop through the images array and create elements dynamically
        images.forEach(function(image) {
            var div = document.createElement("div");
            div.classList.add("product-colors-image");
            if (image.border) {
                div.classList.add("product-colors-image-border");
            }
            div.setAttribute("role", "listbox");

            var img = document.createElement("img");
            img.src = image.url;
            img.alt = image.alt;
            img.classList.add("p-image");
            img.setAttribute("itemprop", "image");
            img.style.mixBlendMode = "darken";

            div.appendChild(img);
            wrapper.appendChild(div);
        });

        // Append the new wrapper to the Imagewrappercontainer
        Imagewrappercontainer.appendChild(wrapper);
        attachImageListeners();
    }

    function hideDisabledSizes(data) {
    // Hide and disable sizes which is not available
        document
            .querySelectorAll(".size-custom-attribute")
            .forEach(function(element) {
                var parent = element.closest(".customize-size-container");                
                if (!parent) return;
                var isDisabled = element.hasAttribute("disabled");                
                parent.style.pointerEvents = isDisabled ? "none" : "";
                parent.style.cursor = isDisabled ? "not-allowed" : "";
                if(isDisabled){                    
                    parent.classList.add("out-of-stock");
                } else{
                    parent.classList.remove("out-of-stock");
                }
            });
        
    }

    function resetCustomizeButton(button) {
        if (!button) return;

        button.classList.remove("out-of-stock-button");
        button.textContent = "Next";

        // Important: remove the real disabled state too.
        button.disabled = false;
        button.removeAttribute("disabled");
        button.removeAttribute("aria-disabled");

        button.style.pointerEvents = "";
        button.style.opacity = "";
    }

    function buildOutofStockButton(button) {
        if (!button) return;

        button.classList.add("out-of-stock-button");
        button.textContent = "Out Of Stock";

        // Important: set both real disabled and aria-disabled when truly OOS.
        button.disabled = true;
        button.setAttribute("disabled", "disabled");
        button.setAttribute("aria-disabled", "true");

        button.style.pointerEvents = "none";
        button.style.opacity = "0.5";
    }

    function checkDisabledColors(data) {
        document.querySelectorAll(".product-container").forEach(function(productWrap) {
            var addToCartButton = productWrap.querySelector("#customizeidQr, #customizeid");
            var badge = productWrap.querySelector(".product-image-parent .maf-badge");

            if (!addToCartButton) return;

            var hasColors = productWrap.querySelectorAll('[data-attr="color"] .customize-color-container').length > 0;
            var hasSizes = productWrap.querySelectorAll('[data-attr="size"] .size-custom-attribute').length > 0;
            // Simple/no-option products should keep the server-rendered availability state.
            // Do not reset an out-of-stock simple product back to "Next".
            if (!hasColors && !hasSizes) {
                return;
            }            

            var selectedColor =
                productWrap.querySelector('[data-attr="color"] .customize-color-container.customize-color-active') ||
                productWrap.querySelector('[data-attr="color"] .customize-color-container.selected') ||
                productWrap.querySelector('[data-attr="color"] .color-custom.customize-color-active') ||
                productWrap.querySelector('[data-attr="color"] .color-custom.selected');

            var selectedSize =
                productWrap.querySelector('[data-attr="size"] .size-custom-attribute.selected') ||
                productWrap.querySelector('[data-attr="size"] .customize-size-container.selected') ||
                productWrap.querySelector('[data-attr="size"] .size-custom-attribute.size-active') ||
                productWrap.querySelector('[data-attr="size"] .customize-size-container.size-active');

            var colorRequiredButMissing = hasColors && !selectedColor;
            var sizeRequiredButMissing = hasSizes && !selectedSize;

            // Important:
            // If required attributes are not selected yet, do NOT show Out of Stock.
            // The customer has not selected a real variant combination yet.
            if (colorRequiredButMissing || sizeRequiredButMissing) {
                resetCustomizeButton(addToCartButton);
                if (badge) badge.hidden = true;
                return;
            }

            var selectedColorIsOOS = selectedColor && (
                selectedColor.classList.contains("unselectable") ||
                selectedColor.classList.contains("color-out-of-stock") ||
                selectedColor.getAttribute("aria-disabled") === "true"
            );

            var selectedSizeIsOOS = selectedSize && (
                selectedSize.hasAttribute("disabled") ||
                selectedSize.classList.contains("unselectable") ||
                selectedSize.closest(".customize-size-container")?.classList.contains("out-of-stock")
            );

            if (selectedColorIsOOS || selectedSizeIsOOS) {
                if (badge) badge.hidden = false;
                buildOutofStockButton(addToCartButton);
                return;
            }

            if (badge) badge.hidden = true;
            resetCustomizeButton(addToCartButton);
        });
    }

    checkDisabledColors();
    
    /**
   * @typedef OptionSelectionResponse
   * @type Object
   * @property {string} priceHtml - Updated price HTML code
   * @property {Object} options - Updated Options
   * @property {string} options.id - Option ID
   * @property {UpdatedOptionValue[]} options.values - Option values
   */

    /**
   * Updates DOM using post-option selection Ajax response
   *
   * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
   * @param {jQuery} $productContainer - DOM element for current product
   */
    function updateOptions(optionsHtml, $productContainer) {
    // Update options
        $productContainer.find(".product-options").empty().html(optionsHtml);
    }

    /**
   * @typespec UpdatedQuantity
   * @type Object
   * @property {boolean} selected - Whether the quantity has been selected
   * @property {string} value - The number of products to purchase
   * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
   *     etc.
   */

    /**
   * Updates the quantity DOM elements post Ajax call
   * @param {UpdatedQuantity[]} quantities -
   * @param {jQuery} $productContainer - DOM container for a given product
   */
    function updateQuantities(quantities, $productContainer) {
        if ($productContainer.parent(".bonus-product-item").length <= 0) {
            var optionsHtml = quantities
                .map(function(quantity) {
                    var selected = quantity.selected ? " selected " : "";
                    return (
                        '<option value="' +
            quantity.value +
            '"  data-url="' +
            quantity.url +
            '"' +
            selected +
            ">" +
            quantity.value +
            "</option>"
                    );
                })
                .join("");
            getQuantitySelector($productContainer).empty().html(optionsHtml);
        }
    }
    /**
   * Parses JSON from Ajax call made whenever an attribute value is [de]selected
   * @param {Object} response - response from Ajax call
   * @param {Object} response.product - Product object
   * @param {string} response.product.id - Product ID
   * @param {Object[]} response.product.variationAttributes - Product attributes
   * @param {Object[]} response.product.images - Product images
   * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
   *     attributes have been selected.  Used partially to
   *     determine whether the Add to Cart button can be enabled
   * @param {jQuery} $productContainer - DOM element for a given product.
   */
    function handleVariantResponse(response, $productContainer) {
        var isChoiceOfBonusProducts =
      $productContainer.parents(".choose-bonus-product-dialog").length > 0;
        var isVaraint;
        if (response.product.variationAttributes) {
            updateAttrs(
                response.product.variationAttributes,
                $productContainer,
                response.resources
            );
            isVaraint = response.product.productType === "variant";
            if (isChoiceOfBonusProducts && isVaraint) {
                $productContainer
                    .parent(".bonus-product-item")
                    .data("pid", response.product.id);

                $productContainer
                    .parent(".bonus-product-item")
                    .data("ready-to-order", response.product.readyToOrder);
            }
        }

        // Update primary images
        var primaryImageUrls = response.product.images.large;
        createCarousel(primaryImageUrls, $productContainer);

        // Update pricing
        if (!isChoiceOfBonusProducts) {
            var $priceSelector = $(".prices .price", $productContainer).length
                ? $(".prices .price", $productContainer)
                : $(".prices .price");
            $priceSelector.replaceWith(response.product.price.html);
        }

        // Update promotions
        $productContainer
            .find(".promotions")
            .empty()
            .html(response.product.promotionsHtml);

        updateAvailability(response, $productContainer);

        if (isChoiceOfBonusProducts) {
            var $selectButton = $productContainer.find(".select-bonus-product");
            $selectButton.trigger("bonusproduct:updateSelectButton", {
                product:           response.product,
                $productContainer: $productContainer
            });
        } else {
            // Enable "Add to Cart" button if all required attributes have been selected
            $(
                "button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global"
            )
                .trigger("product:updateAddToCart", {
                    product:           response.product,
                    $productContainer: $productContainer
                })
                .trigger("product:statusUpdate", response.product);
        }

        // Update attributes
        $productContainer
            .find(".main-attributes")
            .empty()
            .html(getAttributesHtml(response.product.attributes));
    }
    /**
   * Generates html for product attributes section
   *
   * @param {array} attributes - list of attributes
   * @return {string} - Compiled HTML
   */
    function getAttributesHtml(attributes) {
        if (!attributes) {
            return "";
        }

        var html = "";

        attributes.forEach(function(attributeGroup) {
            if (attributeGroup.ID === "mainAttributes") {
                attributeGroup.attributes.forEach(function(attribute) {
                    html +=
            '<div class="attribute-values">' +
            attribute.label +
            ": " +
            attribute.value +
            "</div>";
                });
            }
        });

        return html;
    }
    /**
   * Routes the handling of attribute processing depending on whether the attribute has image
   *     swatches or not
   *
   * @param {Object} attrs - Attribute
   * @param {string} attr.id - Attribute ID
   * @param {jQuery} $productContainer - DOM element for a given product
   * @param {Object} msgs - object containing resource messages
   */
    function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
        var attrsWithSwatches = ["color"];

        attrs.forEach(function(attr) {
            if (attrsWithSwatches.indexOf(attr.id) > -1) {
                processSwatchValues(attr, $productContainer, msgs);
            } else {
                processNonSwatchValues(attr, $productContainer);
            }
        });
    }
    /**
   * Process attribute values associated with an attribute that does not have image swatches
   *
   * @param {Object} attr - Attribute
   * @param {string} attr.id - Attribute ID
   * @param {Object[]} attr.values - Array of attribute value objects
   * @param {string} attr.values.value - Attribute coded value
   * @param {string} attr.values.url - URL to de/select an attribute value of the product
   * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
   *     selected.  If there is no variant that corresponds to a specific combination of attribute
   *     values, an attribute may be disabled in the Product Detail Page
   * @param {jQuery} $productContainer - DOM container for a given product
   */
    function processNonSwatchValues(attr, $productContainer) {
        var $attr = '[data-attr="' + attr.id + '"]';
        var $defaultOption = $productContainer.find($attr + " .select-" + attr.id);
        $defaultOption.attr("data-url", attr.resetUrl);

        attr.values.forEach(function(attrValue) {
            var $attrValue = $productContainer.find(
                $attr + ' [data-attr-value="' + attrValue.value + '"]'
            );
            $attrValue.attr("data-url", attrValue.url).removeAttr("disabled");

            if (!attrValue.selectable) {
                $attrValue.attr("disabled", true);
            }
        });
    }
    /**
   * Process the attribute values for an attribute that has image swatches
   *
   * @param {Object} attr - Attribute
   * @param {string} attr.id - Attribute ID
   * @param {Object[]} attr.values - Array of attribute value objects
   * @param {string} attr.values.value - Attribute coded value
   * @param {string} attr.values.url - URL to de/select an attribute value of the product
   * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
   *     selected.  If there is no variant that corresponds to a specific combination of attribute
   *     values, an attribute may be disabled in the Product Detail Page
   * @param {jQuery} $productContainer - DOM container for a given product
   * @param {Object} msgs - object containing resource messages
   */
    function processSwatchValues(attr, $productContainer, msgs) {
        attr.values.forEach(function(attrValue) {
            var $attrValue = $productContainer.find(
                '[data-attr="' +
          attr.id +
          '"] [data-attr-value="' +
          attrValue.value +
          '"]'
            );
            var $swatchButton = $attrValue.parent();

            if (attrValue.selected) {
                $attrValue.addClass("selected");
                $attrValue
                    .siblings(".selected-assistive-text")
                    .text(msgs.assistiveSelectedText);
            } else {
                $attrValue.removeClass("selected");
                $attrValue.siblings(".selected-assistive-text").empty();
            }

            if (attrValue.url) {
                $swatchButton.attr("data-url", attrValue.url);
            } else {
                $swatchButton.removeAttr("data-url");
            }

            // Keep the visual swatch wrapper in sync with the AJAX variation response.
            // The ISML template adds color-out-of-stock on initial page load, but AJAX
            // updates only run through this JS path, so we must update it here too.
            var isSelectable = !!attrValue.selectable;
            var hasSelectionUrl = !!attrValue.url;
            var isOutOfStock = !isSelectable || !hasSelectionUrl;

            $attrValue.removeClass("selectable unselectable");
            $attrValue.addClass(isSelectable ? "selectable" : "unselectable");

            $swatchButton.removeClass("selectable unselectable color-out-of-stock");
            $swatchButton.addClass(isSelectable ? "selectable" : "unselectable");

            if (isOutOfStock) {
                $swatchButton.addClass("color-out-of-stock");
                $swatchButton.attr("aria-disabled", "true");
            } else {
                $swatchButton.removeAttr("aria-disabled");
            }

        });
    }
    /**
   * Dynamically creates Bootstrap carousel from response containing images
   * @param {Object[]} imgs - Array of large product images,along with related information
   * @param {jQuery} $productContainer - DOM element for a given product
   */
    function createCarousel(imgs, $productContainer) {
        var carousel = $productContainer.find(".carousel");
        $(carousel).carousel("dispose");
        var carouselId = $(carousel).attr("id");
        $(carousel)
            .empty()
            .append(
                '<div class="carousel-inner" role="listbox"  style="mix-blend-mode: darken;"></div>'
            );
        for (var i = 0; i < imgs.length; i++) {
            $(
                '<div class="carousel-item"><img src="' +
          imgs[i].url +
          '" class="d-block img-fluid" alt="' +
          imgs[i].alt +
          " image number " +
          parseInt(imgs[i].index, 10) +
          '" title="' +
          imgs[i].title +
          '" itemprop="image" /></div>'
            ).appendTo($(carousel).find(".carousel-inner"));
            $(
                '<li data-target="#' +
          carouselId +
          '" data-slide-to="' +
          i +
          '" class=""></li>'
            ).appendTo($(carousel).find(".carousel-indicators"));
        }
        $($(carousel).find(".carousel-item")).first().addClass("active");
        $($(carousel).find(".carousel-indicators > li")).first().addClass("active");
        if (imgs.length === 1) {
            $(
                $(carousel).find('.carousel-indicators, a[class^="carousel-control-"]')
            ).detach();
        }
        $(carousel).carousel();
        $($(carousel).find(".carousel-indicators")).attr("aria-hidden", true);
    }

    /**
   * Updates the availability status in the Product Detail Page
   *
   * @param {Object} response - Ajax response object after an
   *                            attribute value has been [de]selected
   * @param {jQuery} $productContainer - DOM element for a given product
   */
    function updateAvailability(response, $productContainer) {
        var availabilityValue = "";
        var availabilityMessages = response.product.availability.messages;
        if (!response.product.readyToOrder) {
            availabilityValue =
        "<li><div>" + response.resources.info_selectforstock + "</div></li>";
        } else {
            availabilityMessages.forEach(function(message) {
                availabilityValue += "<li><div>" + message + "</div></li>";
            });
        }

        $($productContainer).trigger("product:updateAvailability", {
            product:           response.product,
            $productContainer: $productContainer,
            message:           availabilityValue,
            resources:         response.resources
        });
    }
    $("body").on("product:afterAttributeSelect", function(e, response) {
        console.log('product:afterAttributeSelect');
        if ($(".modern-product-detail>.bundle-items").length) {
            response.container.data("pid", response.data.product.id);
            response.container.find(".product-id").text(response.data.product.id);              
        } else if ($(".product-set-detail").eq(0)) {
            response.container.data("pid", response.data.product.id);
            response.container.find(".product-id").text(response.data.product.id);
        } else {
            $(".product-id").text(response.data.product.id);
            $('.modern-product-detail:not(".bundle-item")').data( 
                "pid",
                response.data.product.id
            );
        }
        var dataUrl = $("#selectedVariationURL").attr("data-url");
        var pathname = window.location.pathname;
        if (pathname && typeof pathname === 'string') {
            var withoutExtension = pathname.slice(0, pathname.lastIndexOf('.html'));
        }
        if(withoutExtension){
            var lastSlashIndex = withoutExtension.lastIndexOf('/');
            var editPid = withoutExtension.slice(lastSlashIndex + 1);
        }
        if (editPid && editPid === response.data.product.id) {
            $("#customizeid , #customizeidQr")
                .text("Next")
                .css({ opacity: "1", "pointer-events": "auto" });
            return;
        }

        $.ajax({            
            url:    dataUrl,
            method: "POST",
            data:   { 
                selectedVariant: response.data.product.id,
                editPid:         editPid
            },
            success: function(response) {
                // EC-1114:Prevent users from adding a duplicate product while editing an existing cart item.
                // Allow the original product being edited, but block switching to a variant that already exists in the cart.
                if (response.inCart && response.selectedVariant !== response.editingProduct) {
                    $("#customizeid , #customizeidQr")
                        .text("Already In Your Cart")
                        .css({ opacity: "0.5", "pointer-events": "none" });
                } else {
                    $("#customizeid , #customizeidQr")
                        .text("Next")
                        .css({ opacity: "1", "pointer-events": "auto" });
                }
            },
            error: function(err) {
                console.error("Error fetching product variation:", err);
            }
        });
    
    });
    $(".bs-canvas-overlay-filter, .offcanvas-close-button").click(function() {
        $(".offcanvas-body").scrollTop(0);
    });
      
    $('#customizeEngraveid.next-plan').click(function() {
        var pid = null;
        $(".modern-product-detail").each(function() {
            pid = $(this).find(".product-id").text();
        });
        var engravingline = {};
        $("#modern_engraving_form")
            .find(".engraveInput")
            .each(function(index, input) {
                engravingline[('engravingline' + (index + 1))] = $(input).val();
            });
        var idType = $('#idType').text().trim();
        var url = $(".move-to-plan").val();
        var editProductID = $('input[name="editProductID"]').val();
        
        var data = {
            pid:           pid,
            editProductID: editProductID,
            idType:        idType
        };
        $.each(engravingline, function(key, value) {
            data[key] = value;
        });
    
        $.ajax({
            url:     url,
            type:    "POST",
            data:    data,
            success: function(response) {
                if (response.redirectUrl) {
                    sessionStorage.setItem('productID', response.productId);
                    window.location.href = response.redirectUrl;
                }
            },
            error: function(xhr, status, error) {
                console.log("Error:", error);
            }
        });
    });

    $(document).on("click", '[data-attr="color"] div.color-custom', function(e) {        
        e.preventDefault();

        if (
            $(this).hasClass("color-out-of-stock") ||
            $(this).hasClass("unselectable") ||
            $(this).attr("aria-disabled") === "true" ||
            !$(this).attr("data-url")
        ) {
            return;
        }

        checkDisabledColors();

        var $productContainer = $(this).closest(".set-item");
        if (!$productContainer.length) {
            $productContainer = $(this).closest(".modern-product-detail");
        }
        // $(".pdpLoader").show();
        attributeSelect($(this).attr("data-url"), $productContainer);
    });

    $(document).on(
        "change",
        'select[class*="select-"], .options-select',
        function(e) {
            e.preventDefault();

            var $productContainer = $(this).closest(".set-item");
            if (!$productContainer.length) {
                $productContainer = $(this).closest(".modern-product-detail");
            }
            attributeSelect(e.currentTarget.value, $productContainer);
        }
    );

    $(document).on(
        "click",
        '[data-attr="size"] div.size-custom-attribute',
        function(e) {
            e.preventDefault();
            console.log('on click size');
            if ($(this).attr("disabled")) {
                return;
            }
            var $productContainer = $(this).closest(".set-item");
            if (!$productContainer.length) {
                $productContainer = $(this).closest(".modern-product-detail");
            }

            attributeSelect($(this).attr("data-url"), $productContainer, "size");
        }
    );

    $(document).on(
        "click",
        "button.add-to-cart, button.add-to-cart-global",
        function() {
            var addToCartUrl;
            var pid;
            var pidsObj;
            var setPids;

            $("body").trigger("product:beforeAddToCart", this);

            if ($(".set-items").length && $(this).hasClass("add-to-cart-global")) {
                setPids = [];

                $(".modern-product-detail").each(function() {
                    if (!$(this).hasClass("product-set-detail")) {
                        setPids.push({
                            pid:     $(this).find(".product-id").text(),
                            qty:     $(this).find(".quantity-select").val(),
                            options: getOptions($(this))
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = getPidValue($(this));

            var $productContainer = $(this).closest(".modern-product-detail");
            if (!$productContainer.length) {
                $productContainer = $(this)
                    .closest(".quick-view-dialog")
                    .find(".modern-product-detail");
            }

            addToCartUrl = getAddToCartUrl();

            var form = {
                pid:           pid,
                pidsObj:       pidsObj,
                childProducts: getChildProducts(),
                quantity:      getQuantitySelected($(this))
            };

            if (!$(".bundle-item").length) {
                form.options = getOptions($productContainer);
            }

            $(this).trigger("updateAddToCartFormData", form);
            if (addToCartUrl) {
                $.ajax({
                    url:     addToCartUrl,
                    method:  "POST",
                    data:    form,
                    success: function(data) {
                        handlePostCartAdd(data);
                        $("body").trigger("product:afterAddToCart", data);
                        $.spinner().stop();
                        miniCartReportingUrl(data.reportingURL);
                    },
                    error: function() {
                        $.spinner().stop();
                    }
                });
            }
            setTimeout(function() {
                $("html, body").animate({
                    scrollTop: $(".minicart-link").offset().top - 200
                });
                var cartURL = $(".minicart-link, .minicart-icon").attr("href");
                location.href = cartURL;
            }, 1500);
        }
    );

    /**
   * Retrieves the relevant pid value
   * @param {jquery} $el - DOM container for a given add to cart button
   * @return {string} - value to be used when adding product to cart
   */
    function getPidValue($el) {
        var pid;

        if ($("#quickViewModal").hasClass("show") && !$(".product-set").length) {
            pid = $($el)
                .closest(".modal-content")
                .find(".product-quickview")
                .data("pid");
        } else if ($(".product-set-detail").length || $(".product-set").length) {
            pid = $($el).closest(".modern-product-detail").find(".product-id").text();
        } else {
            pid = $('.modern-product-detail:not(".bundle-item")').data("pid");
        }

        return pid;
    }

    /**
   * Retrieves url to use when adding a product to the cart
   *
   * @return {string} - The provided URL to use when adding a product to the cart
   */
    function getAddToCartUrl() {
        return $(".add-to-cart-url").val();
    }

    /**
   * Retrieves the bundle product item ID's for the Controller to replace bundle master product
   * items with their selected variants
   *
   * @return {string[]} - List of selected bundle product item ID's
   */
    function getChildProducts() {
        var childProducts = [];
        $(".bundle-item").each(function() {
            childProducts.push({
                pid:      $(this).find(".product-id").text(),
                quantity: parseInt($(this).find("label.quantity").data("quantity"), 10)
            });
        });

        return childProducts.length ? JSON.stringify(childProducts) : [];
    }

    /**
   * Retrieves the value associated with the Quantity pull-down menu
   * @param {jquery} $el - DOM container for the relevant quantity
   * @return {string} - value found in the quantity input
   */
    function getQuantitySelected($el) {
        return getQuantitySelector($el).val();
    }

    /**
   * Retrieve contextual quantity selector
   * @param {jquery} $el - DOM container for the relevant quantity
   * @return {jquery} - quantity selector DOM container
   */
    function getQuantitySelector($el) {
        var quantitySelected;
        if ($el && $(".set-items").length) {
            quantitySelected = $($el)
                .closest(".modern-product-detail")
                .find(".quantity-select");
        } else if ($el && $(".product-bundle").length) {
            var quantitySelectedModal = $($el)
                .closest(".modal-footer")
                .find(".quantity-select");
            var quantitySelectedPDP = $($el)
                .closest(".bundle-footer")
                .find(".quantity-select");
            if (quantitySelectedModal.val() === undefined) {
                quantitySelected = quantitySelectedPDP;
            } else {
                quantitySelected = quantitySelectedModal;
            }
        } else {
            quantitySelected = $(".quantity-select");
        }
        return quantitySelected;
    }

    /**
   * Retrieve product options
   *
   * @param {jQuery} $productContainer - DOM element for current product
   * @return {string} - Product options and their selected values
   */
    function getOptions($productContainer) {
        var options = $productContainer
            .find(".product-option")
            .map(function() {
                var $elOption = $(this).find(".options-select");
                var urlValue = $elOption.val();
                var selectedValueId = $elOption
                    .find('option[value="' + urlValue + '"]')
                    .data("value-id");
                return {
                    optionId:        $(this).data("option-id"),
                    selectedValueId: selectedValueId
                };
            })
            .toArray();

        return JSON.stringify(options);
    }

    /**
   * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
   * @param {string} response - ajax response from clicking the add to cart button
   */
    function handlePostCartAdd(response) {
        $(".minicart").trigger("count:update", response);
        var messageType = response.error ? "alert-danger" : "alert-success";
        // show add to cart toast
        if (
            response.newBonusDiscountLineItem &&
      Object.keys(response.newBonusDiscountLineItem).length !== 0
        ) {
            chooseBonusProducts(response.newBonusDiscountLineItem);
        } else {
            if ($(".add-to-cart-messages").length === 0) {
                $("body").append('<div class="add-to-cart-messages"></div>');
            }

            $(".add-to-cart-messages").append(
                '<div class="alert ' +
          messageType +
          ' add-to-basket-alert text-center" role="alert">' +
          response.message +
          "</div>"
            );

            setTimeout(function() {
                $(".add-to-basket-alert").remove();
            }, 5000);
        }
    }

    /**
   * Retrieves url to use when adding a product to the cart
   *
   * @param {Object} data - data object used to fill in dynamic portions of the html
   */
    function chooseBonusProducts(data) {
        $(".modal-body").spinner().start();

        if ($("#chooseBonusProductModal").length !== 0) {
            $("#chooseBonusProductModal").remove();
        }
        var bonusUrl;
        if (data.bonusChoiceRuleBased) {
            bonusUrl = data.showProductsUrlRuleBased;
        } else {
            bonusUrl = data.showProductsUrlListBased;
        }

        var htmlString =
      "<!-- Modal -->" +
      '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">' +
      '<span class="enter-message sr-only" ></span>' +
      '<div class="modal-dialog choose-bonus-product-dialog" ' +
      'data-total-qty="' +
      data.maxBonusItems +
      '"' +
      'data-UUID="' +
      data.uuid +
      '"' +
      'data-pliUUID="' +
      data.pliUUID +
      '"' +
      'data-addToCartUrl="' +
      data.addToCartUrl +
      '"' +
      'data-pageStart="0"' +
      'data-pageSize="' +
      data.pageSize +
      '"' +
      'data-moreURL="' +
      data.showProductsUrlRuleBased +
      '"' +
      'data-bonusChoiceRuleBased="' +
      data.bonusChoiceRuleBased +
      '">' +
      "<!-- Modal content-->" +
      '<div class="modal-content">' +
      '<div class="modal-header">' +
      '    <span class="">' +
      data.labels.selectprods +
      "</span>" +
      '    <button type="button" class="close pull-right" data-dismiss="modal">' +
      '        <span aria-hidden="true">&times;</span>' +
      '        <span class="sr-only"> </span>' +
      "    </button>" +
      "</div>" +
      '<div class="modal-body"></div>' +
      '<div class="modal-footer"></div>' +
      "</div>" +
      "</div>" +
      "</div>";
        $("body").append(htmlString);
        $(".modal-body").spinner().start();

        $.ajax({
            url:      bonusUrl,
            method:   "GET",
            dataType: "json",
            success:  function(response) {
                // eslint-disable-next-line no-undef
                var parsedHtml = parseHtml(response.renderedTemplate);
                $("#chooseBonusProductModal .modal-body").empty();
                $("#chooseBonusProductModal .enter-message").text(
                    response.enterDialogMessage
                );
                $("#chooseBonusProductModal .modal-header .close .sr-only").text(
                    response.closeButtonText
                );
                $("#chooseBonusProductModal .modal-body").html(parsedHtml.body);
                $("#chooseBonusProductModal .modal-footer").html(parsedHtml.footer);
                $("#chooseBonusProductModal").modal("show");
                $.spinner().stop();
            },
            error: function() {
                $.spinner().stop();
            }
        });
    }
    /**
   * Makes a call to the server to report the event of adding an item to the cart
   *
   * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
   */
    function miniCartReportingUrl(url) {
        if (url) {
            $.ajax({
                url:     url,
                method:  "GET",
                success: function() {
                    // reporting urls hit on the server
                },
                error: function() {
                    // no reporting urls hit on the server
                }
            });
        }
    }
    
});

document.onreadystatechange = function(e) {
    if (document.readyState === 'complete') {
        var yotpoElement = document.getElementById('yotpo-main-widget-btn');
        if (!yotpoElement) {
            $('.custom-yotpo-header').addClass('d-none');
        }
    }
};

// Extracting availability data from schema json
// $(document).ready(function() {
//     // Select the script tag with type="application/ld+json"
//     var schemaScript = $('script[type="application/ld+json"]');

//     if (schemaScript.length > 0) {
//         // Get the text content of the script tag
//         var jsonString = schemaScript.text();

//         try {
//             // Parse the JSON string into a JavaScript object
//             var schemaData = JSON.parse(jsonString);

//             // Working with the schemaData object
//             console.log("In Stock?:", schemaData.offers.availability);

//             if (schemaData.offers.availability.includes("OutOfStock")) {
//                 buildOutofStockSingleProduct();                
//             }

//         } catch (e) {
//             console.error("Error parsing JSON:", e);
//         }
//     } else {
//         console.log("No application/ld+json script tag found on this page.");
//     }
// });
